import { useTableSearch } from "~/hooks/useTableSearch"
import {
  toStoreSearchField,
  type StoreSearchField,
  type StoreSearchOption,
} from "~/utils/storeSearch"

export function useStoreSearch(
  tableId: string,
  options: readonly StoreSearchOption[],
  defaultSearchBy: StoreSearchField = "all",
) {
  const { searchText, setSearchText, searchBy, setSearchBy } = useTableSearch(
    tableId,
    defaultSearchBy,
  )
  return {
    search: searchText,
    setSearch: setSearchText,
    searchBy: toStoreSearchField(searchBy, options),
    setSearchBy,
  }
}
